import "./styles.scss"

import React from "react"
import { Link } from "gatsby"
import { motion } from "framer-motion"

import { useLocale } from "context/locale"
import { useWindow } from "context/window"

import RoundedWrapper from "components/RoundedWrapper"
import ShareList from "components/ShareList"
import ShareDropdown from "components/ShareDropdown"

import { fadeAnimation } from "utils"

import IcoSlickPrev from "assets/icons/slick-button-prev.svg"
import IcoSlickNext from "assets/icons/slick-button-next.svg"

const PostContent = ({ data }) => {
  const { t } = useLocale()
  const { isBrowser } = useWindow()

  const location = isBrowser ? window.location.href : null

  const getUri = slug =>
    slug ? `${data?.language?.code === "PL" ? "/pl" : ""}/blog/${slug}` : "/"

  return (
    <section className="post-content">
      <RoundedWrapper className="post-content__wrapper">
        <motion.div {...fadeAnimation}>
          <div
            className="post-content__image"
            style={{
              backgroundImage: `url('${data?.featuredImage?.node?.localFile?.publicURL}')`,
            }}
          />

          <div className="post-content__info">
            <div>
              <p>
                <strong>{t("Published:")}</strong>{" "}
                {data?.date.split("T")[0].split("-").reverse().join(".")}
              </p>
              <p>
                <strong>{t("Category:")}</strong>{" "}
                {data?.categories?.nodes[0]?.name}
              </p>
            </div>

            <ShareList
              className="post-content__share-list"
              label={t("Share")}
              url={location}
            />
            <ShareDropdown
              className="post-content__share-dropdown"
              url={location}
            />
          </div>
        </motion.div>

        <motion.div className="post-content__content" {...fadeAnimation}>
          <div className="row justify-content-center">
            <div className="col-xl-10">
              <h2>{data?.title}</h2>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-xl-8">
              <div
                className="post-content__content-inner"
                dangerouslySetInnerHTML={{ __html: data?.content }}
              />

              <div className="post-content__nav">
                <Link to={getUri(data?.next?.slug)}>
                  {data?.next && (
                    <>
                      <span>
                        <img src={IcoSlickPrev} alt="" />
                      </span>
                      <p>{data?.next?.title}</p>
                    </>
                  )}
                </Link>
                <Link to={getUri(data?.prev?.slug)}>
                  {data?.prev && (
                    <>
                      <span>
                        <img src={IcoSlickNext} alt="" />
                      </span>
                      <p>{data?.prev?.title}</p>
                    </>
                  )}
                </Link>
              </div>
            </div>
          </div>
        </motion.div>
      </RoundedWrapper>
    </section>
  )
}

export default PostContent
